<p [class.from-offers]="isFromOffers" id="{{'countdown' + id}}" class="{{'countdown' + id}}" *ngIf="id && !expired" ></p>
<span *ngIf="expired">00:00:00</span>